import { render } from "./detail.vue?vue&type=template&id=7a1757da&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"

import "./detail.vue?vue&type=style&index=0&id=7a1757da&scoped=true&lang=css"
import "./detail.vue?vue&type=style&index=1&id=7a1757da&lang=css"

import exportComponent from "D:\\project\\item\\jts\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a1757da"]])

export default __exports__